import React from 'react'
import ContractsListItemContainer from './ContractsListItemContainer'

const ContractsListItem = props => (
  <ContractsListItemContainer {...props} data-test="component-contracts-list-item" />
)

export default ContractsListItem
